<template>
    <div>
        <el-row v-if="isshow" :gutter="40">
            <el-col :xs="20" :sm="20" :md="10" :lg="10" :xl="10" style="margin-bottom:10px;">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>参数</span>
                    </div>
                    <el-form ref="formData" label-width="20px">
                        <div style="display: flex;">
                            <div style="width: 50%;margin-right:20px;">
                                <el-form-item>
                                    <el-select
                                        v-model="formData.website"
                                        ref="carrerSelect"
                                        style="width: 100%;"
                                        size="small"
                                        filterable
                                        @change="inputChange(asin)"
                                    >
                                        <el-option
                                            v-for="item in us_arr"
                                            :key="item.us"
                                            :label="item.title"
                                            :value="item.title"
                                            :disabled="item.disabled">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-input style="width: 100%;" placeholder="ASIN" v-model="asin" size="small" @change="inputChange" v-loading="inputloading"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-input style="width: 100%;" placeholder="卖方ID" v-model="formData.sellerID" size="small"></el-input>
                                </el-form-item>
                            </div>
                            <div style="width: 30%;">
                                <img v-if="img" style="width: 100%;max-width: 132px;" :src="img" alt="">
                            </div>
                        </div>
                        <el-form-item>
                            <el-popover
                                ref="popover"
                                @show="clickFolders"
                                :popper-append-to-body="false"
                                :append-to-body="false"
                                class="button-star"
                                placement="bottom-start"
                                title
                                popper-class="select-popper"
                                trigger="click">
                                <div v-loading="loadingFolders" style="width: 200px;">
                                    <div class="dropdown-header">
                                        <span>搜索到文件夹：</span>
                                    </div>
                                    <div style="margin: 0 10px 5px;">
                                        <el-input size="small" v-model="nameFolders" @input="inputFolders" style="width: 180px;" placeholder="输入文件夹名称" clearable></el-input>
                                    </div>
                                    <div class="dropdown-header">
                                        <span class="dropdown-header__title">文件夹</span>
                                        <span class="dropdown-header__title">关键词</span>
                                    </div>
                                    <div v-if="nameFolders.length == 0" class="dropdown-items">
                                        <div v-for="(item, i) in this.arrFolders" :key="i" class="dropdown-item" @click="onkeyword(item)">
                                            <div class="dropdown-item-txt">{{item.name}}</div>
                                            <span>{{item.kw_count}}</span>
                                        </div>
                                    </div>
                                    <div v-if="nameFolders.length != 0" class="dropdown-items">
                                        <div v-for="(item, i) in this.arrFolders_search" :key="i" class="dropdown-item" @click="onkeyword(item)">
                                            <span>{{item.name}}</span>
                                            <span>{{item.kw_count}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div style="display: inline-block;" slot="reference">
                                    <div class="button-plus">
                                        <i class="el-icon-upload2" style="font-size: 14px;color: #6a6c6f !important;"></i>
                                        导入文件夹中的关键词
                                    </div>
                                </div>
                            </el-popover>
                            <div class="pushed-folders">
                                <div class="pushed-keyword" v-for="(item, i) in this.foldersArr" :key="i">
                                    <span>{{item.name}}</span>
                                    <i class="el-icon-close" @click="deleteFoldersKeyword(item)"></i>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <div class="ic-textarea-title">
                                <div style="margin-top: auto!important;width: 100%!important;">
                                    <span class="total-characters-label">总计:</span>
                                    <span style="color: #17a2b8!important;">{{arr.length}}</span>
                                    <span style="color: #17a2b8!important;"> / 200</span>
                                    <span> 关键词/短语</span>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-input
                                v-model="str"
                                :rows="12"
                                @change="oninput"
                                @keyup.enter.native="oninput"
                                onkeyup="value=value.replace(/[^\r\n0-9 a-zA-Z_-]/g,'')"
                                type="textarea"
                                style="width: 100%;"
                                placeholder="输入关键字或关键短语，已换行区分"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-checkbox v-model="checkedRemove">删除重复项</el-checkbox>
                        </el-form-item>
                        <el-form-item>
                            <div class="ic-textarea-title" style="margin-top: 10px;">
                                <div style="margin-top: auto!important;width: 100%!important;">
                                    <el-button type="primary" @click="checkKeywords" :disabled="inputloading">检查关键字</el-button>
                                </div>
                            </div>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-col>
            <el-col :xs="28" :sm="28" :md="14" :lg="14" :xl="14">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>结果</span>
                        <el-button style="float: right; padding: 3px 0;" size="mini" type="primary" @click="onExcel">导出Excel</el-button>
                        <download-excel
                            id="download_excel"
                            class = "export-excel-wrapper"
                            :data = "json_data"
                            :fields = "json_fields"
                            style="display: none;"
                            name = "关键词搜索查找数据.xls">
                        </download-excel>
                    </div>
                    <div class="table-responsive">
                        <table class="table-bordered" id="table-bordered">
                            <thead>
                                <tr>
                                    <th class="th">
                                        <div class="th-check-all" id="th-check-all">
                                            <!-- <div class="squaredTwo">
                                                <input type="checkbox" value="None" id="squaredTwo" name="check" checked="checked" />
                                                <label for="squaredTwo"></label>
                                            </div> -->
                                            <span>关键词</span>
                                        </div>
                                    </th>
                                    <th class="th">
                                        <div class="th-title" title="传统的“ASIN+关键字”测试">
                                            传统索引
                                        </div>
                                    </th>
                                    <th class="th">
                                        <div class="th-title" title="“现场asin”测试">
                                            字段ASIN索引
                                        </div>
                                    </th>
                                    <th class="th">
                                        <div class="th-title" title="店面测试">
                                            店面索引
                                        </div>
                                    </th>
                                    <th class="th">
                                        <div class="th-title">
                                            累计
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody id="tbody_id" style="height: 40px;line-height: 40px">
                                <tr>
                                    <td colspan="5">
                                        <div style="text-align: center!important;">等你开始搜索。</div>
                                    </td>
                                </tr>
                            </tbody>
                            <!-- <tbody id="tbody_id">
                                <tr>
                                    <td class="kw-td">
                                            <span>1</span>
                                    </td>
                                    <td class="kw-td">
                                        <a href="https://www.amazon.com/s/ref=nb_sb_noss?url=search-alias%3Daps&field-keywords=B093RRNMBF%201">
                                            <span  style="font-weight:900;">一</span>
                                        </a>
                                    </td>
                                    <td class="kw-td">
                                        <a href="https://www.amazon.com/s/ref=nb_sb_noss_2?url=search-alias%3Daps&field-keywords=1&field-asin=B093RRNMBF">
                                            <span  style="font-weight:900;">一</span>
                                        </a>
                                    </td>
                                    <td class="kw-td">
                                        <a target="_blank">
                                            <span style="font-weight:900;">X</span>
                                        </a>
                                    </td>
                                    <td class="kw-td">
                                        <a target="_blank">
                                        <span  style="font-weight:900;">一</span>
                                        </a>
                                    </td>
                                </tr>
                            </tbody> -->
                        </table>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <crx-view v-else></crx-view>
        <div id="crxShowTipDialog" @click="showTipDialog"></div>
        <index-check-tip-dialog ref="tipDialogRef"></index-check-tip-dialog>
    </div>
</template>

<script>
import * as api from "@/api/Product/Product";
import { str_arr, checkPlug } from "@/utils/method";
import CrxView from "@/components/crxView";
import IndexCheckTipDialog from "./indexCheckTipDialog";
export default {
    components: {IndexCheckTipDialog, CrxView },
    data() {
        return {
            formData: {
                website: "www.amazon.com",
                asin: ""
            },
            json_fields: {
                关键词: "Keyword",
                传统索引: "traditional",
                字段ASIN索引: "field_asin",
                店面索引: "storefront",
                累计: "cumulative"
            },
            json_data: [],
            json_meta: [
                [
                    {
                        key: "charset",
                        value: "utf- 8"
                    }
                ]
            ],
            us_arr: [
                {
                    us: "US", // 美国
                    title: "www.amazon.com"
                },
                {
                    us: "UK", // 英国
                    title: "www.amazon.co.uk"
                },
                {
                    us: "DE", // 德国
                    title: "www.amazon.de"
                },
                {
                    us: "IT", // 意大利
                    title: "www.amazon.it"
                },
                {
                    us: "ES", // 西班牙
                    title: "www.amazon.es"
                },
                {
                    us: "FR", // 法国
                    title: "www.amazon.fr"
                }

                // {
                //     us: "CA",
                //     title: "www.amazon.ca",
                //     disabled: true
                // },
                // {
                //     us: "MX",
                //     title: "www.amazon.com.mx",
                //     disabled: true
                // },
                // {
                //     us: "FR",
                //     title: "www.amazon.fr",
                //     disabled: true
                // },
                // {
                //     us: "IT",
                //     title: "www.amazon.it",
                //     disabled: true
                // },
                // {
                //     us: "ES",
                //     title: "www.amazon.es",
                //     disabled: true
                // },
                // {
                //     us: "JP",
                //     title: "www.amazon.co.jp",
                //     disabled: true
                // },
                // {
                //     us: "IN",
                //     title: "www.amazon.in",
                //     disabled: true
                // },
                // {
                //     us: "AU",
                //     title: "www.amazon.com.au",
                //     disabled: true
                // }
            ],
            checked: true,
            checkedRemove: true,
            loadingFolders: false,
            KeywordShow: false,
            inputloading: false,
            arrFolders: [],
            arrFolders_search: [],
            nameFolders: "",
            str: "",
            img: null,
            isshow: false,
            asin: "",
            arr: [],
            foldersArr: []
        };
    },
    mounted() {
        checkPlug(()=>this.isshow = true, ()=>this.$downLoadPlug())
    },
    methods: {
        showTipDialog(){
            let url = "https://" + this.formData.website + "/s/ref=nb_sb_noss?url=search-alias%3Daps&field-keywords=" +  this.formData.asin + "+" + this.arr[0].replace(/ /g, '+');
            this.$refs.tipDialogRef.openDialog(url)
        },
        xpath_(xpathToExecute, data) {
            var result = [];
            var nodesSnapshot = document.evaluate(
                xpathToExecute,
                data,
                null,
                XPathResult.ORDERED_NODE_SNAPSHOT_TYPE,
                null
            );
            for (var i = 0; i < nodesSnapshot.snapshotLength; i++) {
                result.push(nodesSnapshot.snapshotItem(i));
            }
            return result;
        },
        //导出excel
        onExcel() {
            let aresults_detail_list = this.xpath_(
                "//tbody[@id='tbody_id']/tr",
                document
            );
            let excelarr = [];
            try {
                for (var i = 0; i < aresults_detail_list.length; i++) {
                    let tds = this.xpath_("./td", aresults_detail_list[i]);
                    let isshow = document
                        .evaluate(
                            ".//input",
                            tds[0],
                            null,
                            XPathResult.ANY_TYPE,
                            null
                        )
                        .iterateNext().checked;
                    if (isshow) {
                        let obj = {};
                        obj.Keyword = document
                            .evaluate(
                                "./span",
                                tds[0],
                                null,
                                XPathResult.ANY_TYPE,
                                null
                            )
                            .iterateNext().innerText;
                        obj.traditional = document
                            .evaluate(
                                "./a/span",
                                tds[1],
                                null,
                                XPathResult.ANY_TYPE,
                                null
                            )
                            .iterateNext().innerText;
                        obj.field_asin = document
                            .evaluate(
                                "./a/span",
                                tds[2],
                                null,
                                XPathResult.ANY_TYPE,
                                null
                            )
                            .iterateNext().innerText;
                        obj.storefront = document
                            .evaluate(
                                "./a/span",
                                tds[3],
                                null,
                                XPathResult.ANY_TYPE,
                                null
                            )
                            .iterateNext().innerText;
                        obj.cumulative = document
                            .evaluate(
                                "./a/span",
                                tds[4],
                                null,
                                XPathResult.ANY_TYPE,
                                null
                            )
                            .iterateNext().innerText;
                        excelarr.push(obj);
                    }
                }
                this.json_data = excelarr;
                if (excelarr.length == 0) {
                    return this.$message({
                        type: "error",
                        message: "请勾选需要导出的数据！"
                    });
                }
                var downloadExcel = document.getElementById("download_excel");
                setTimeout(function() {
                    downloadExcel.click();
                }, 100);
            } catch (err) {
                return this.$message({
                    type: "error",
                    message: "请等待全部读取完成！"
                });
            }
        },
        //爬取
        checkKeywords() {
            if (this.asin.length == 0) {
                return this.$message({
                    type: "error",
                    message: "请输入ASIN"
                });
            }
            if (this.formData.asin == "") {
                return this.$alert("您输入的ASIN不存在或者已下架.", "提示", {
                    confirmButtonText: "确定",
                    type: "warning"
                });
            }
            if (this.arr.length == 0) {
                return this.$message({
                    type: "error",
                    message: "请输入关键词，或关键词短语"
                });
            }
            if (this.arr.length > 200) {
                return this.$message({
                    type: "error",
                    message: "请输入200以内或者200的关键词"
                });
            }
            var tbody = document.getElementById("tbody_id");
            tbody.remove();
            var table = document.getElementById("table-bordered");
            var tbody_new = document.createElement("tbody");
            tbody_new.id = "tbody_id";
            table.appendChild(tbody_new);
            var div = document.getElementById("div_big_data");
            let obj = {};
            obj.website = this.formData.website;
            obj.asin = this.formData.asin;
            obj.sellerID = this.formData.sellerID;
            obj.arr = this.arr;
            div.innerText = JSON.stringify(obj);
            div.click();
        },
        //获取文件列表
        clickFolders() {
            this.loadingFolders = true;
            api.kw_folder_all()
                .then(res => {
                    this.loadingFolders = false;
                    if (res.code === 0) {
                        this.arrFolders = res.data;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loadingFolders = false;
                });
        },
        //文件夹搜索
        inputFolders(val) {
            let arr = JSON.parse(JSON.stringify(this.arrFolders));
            let searcharr = [];
            arr.forEach(item => {
                if (item.name.indexOf(val.toLowerCase()) != -1) {
                    searcharr.push(item);
                }
            });
            this.arrFolders_search = searcharr;
        },
        //获取ASIN内容数据
        inputChange(val) {
            if (val.length < 10) {
                return;
            }
            this.inputloading = true;
            let us_arr_value = null;
            for (let i = 0; i < this.us_arr.length; i++) {
                if (this.us_arr[i].title == this.formData.website) {
                    us_arr_value = this.us_arr[i].us;
                    break;
                }
            }
            api.asin_info({ asin: val, country_code: us_arr_value })
                .then(res => {
                    this.inputloading = false;
                    if (res.code === 0) {
                        this.formData.asin = this.asin;
                        this.img = res.data.image_url;
                    } else {
                        this.formData.asin = "";
                        this.img = null;
                    }
                })
                .catch(() => {
                    this.inputloading = false;
                    this.$message({
                        type: "error",
                        message: "网络出现问题，请刷新页面！"
                    });
                });
        },
        // 数组按换行符拼接成字符串
        arr_str(arr) {
            let str = "";
            if (arr.length != 0) {
                for (let i = 0; i < arr.length; i++) {
                    str += arr[i] + "\n";
                }
            }
            return str;
        },
        //数组对比，相差部分
        getdifferentArr(arry1, arry2) {
            var arry3 = [];
            var tmp = arry1.concat(arry2);
            var o = {};
            for (let i = 0; i < tmp.length; i++)
                tmp[i] in o ? o[tmp[i]]++ : (o[tmp[i]] = 1);
            for (let x in o) if (o[x] === 1) arry3.push(x);
            return arry3;
        },
        //输入框方法
        oninput() {
            if (this.checkedRemove) {
                let arr = str_arr(this.str.replace(/[^\r\n0-9 a-zA-Z_-]/g, ""));
                this.arr = Array.from(new Set(arr));
                this.str = this.arr_str(this.arr);
            } else {
                this.arr = str_arr(this.str);
            }
        },
        //获取文件夹中的关键词
        onkeyword(data) {
            if (data.kw_count == 0) {
                return this.$message({
                    type: "error",
                    message: "该文件夹下没有关键词！"
                });
            }
            api.keywords_by_id({ folder_id: data.id }).then(res => {
                if (res.code === 0) {
                    var arr = this.arr.concat(res.data);
                    this.arr = Array.from(new Set(arr));
                    this.str = this.arr_str(this.arr);
                    this.$refs.popover.showPopper = false;
                    for (let i = 0; i < this.foldersArr.length; i++) {
                        if (this.foldersArr[i].id == data.id) return;
                    }
                    this.foldersArr.push(data);
                } else {
                    this.$message({
                        type: "error",
                        message: res.message
                    });
                }
            });
        },
        //删除
        deleteFoldersKeyword(data) {
            if (this.KeywordShow) {
                return;
            }
            this.KeywordShow = true;
            api.keywords_by_id({ folder_id: data.id })
                .then(res => {
                    this.KeywordShow = false;
                    if (res.code === 0) {
                        this.arr = this.getdifferentArr(res.data, this.arr);
                        this.str = this.arr_str(this.arr);
                        for (let i = 0; i < this.foldersArr.length; i++) {
                            if (this.foldersArr[i].id == data.id) {
                                this.foldersArr.splice(i, 1);
                                break;
                            }
                        }
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.KeywordShow = false;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.el-button--mini {
    padding: 5px 5px !important;
}
/deep/ .el-card__header {
    padding: 10px 20px;
}
/deep/ .el-checkbox {
    margin-right: 10px;
}
/deep/ .el-form-item {
    margin-bottom: 4px;
}
.pushed-folders {
    line-height: 19px !important;
    min-height: 28px;
    display: inline-block;
    vertical-align: top;
    border: 1px solid transparent;
}
.pushed-keyword {
    font-size: 14px;
    font-weight: 700;
    color: #343a40;
    display: inline-block;
    vertical-align: middle;
    padding: 3px 7px 3px 3px;
    margin: 5px 0 0 5px;
    border-radius: 4px;
    border: 1px solid #e4e5e7;
    background-color: #fff;
    i {
        margin-left: 5px;
        cursor: pointer;
        font-weight: 700;
    }
}
.dropdown-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 6px 6px 11px;
    font-size: 14px;
    font-weight: 400;
    color: #343a40;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
    box-sizing: border-box;
    .dropdown-item-txt {
        width: 132px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    span {
        padding-right: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        box-sizing: border-box;
    }
}
.dropdown-item:hover {
    background: rgb(240, 240, 240);
}
.dropdown-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: 700;
    color: #003873;
    line-height: 1.2;
    margin: 0;
    padding: 6px 8px 6px 11px;
    cursor: default;
    user-select: none;
}
.dropdown-header__title {
    font-size: 14px;
    font-weight: 600;
    color: #8c8c8c;
}
.dropdown-items {
    overflow-y: auto;
    min-height: 0;
    max-height: 276px;
    transition: height 400ms cubic-bezier(0.5, 0, 0.2, 1);
}
.select-popper {
    .popper__arrow {
        display: none !important;
    }
    margin-top: 3px !important;
    padding: 5px 0 !important;
    box-sizing: border-box !important;
}
.folder {
    color: #003873;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 6px 6px 11px;
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
}
.folder:hover {
    background: rgb(240, 240, 240);
}
.button-plus {
    width: 163px;
    cursor: pointer;
    height: 28px;
    line-height: 28px;
    font-size: 13px;
    padding: 0 5.5px;
    background: #fff;
    box-sizing: border-box;
    border: 1px solid #dcdfe6;
    color: #606266;
    font-weight: 500;
    border-radius: 4px;
}
.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}
.clearfix:after {
    clear: both;
}

.box-card {
    width: 100%;
}
/deep/ ::-webkit-scrollbar {
    width: 7px;
    height: 5px;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-track-piece {
    background-color: #ffff;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:horizontal {
    width: 7px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
</style>
